import { SHOW_CART_ATC_SLIDER } from '../actionTypes/AtcSliderStatusActionTypes';

export const showCartATCSlider = (payload) => ({
    type: SHOW_CART_ATC_SLIDER,
    payload,
});

export default {
    showCartATCSlider,
};
